





























import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { DailyLoadProcessStatus } from '@/api/dashboard/DailyLoadProcessStatus';
import { DailyLoadProcessStatuses } from '@/api/dashboard/DailyLoadProcessStatuses';

@Component({})
export default class DailyLoadProcessStatusPicker extends Vue {
	@Prop() readonly value!: DailyLoadProcessStatus[];

	@Prop({ default: '' })
	label?: DailyLoadProcessStatus;


	selectedValues: {key:string, value:DailyLoadProcessStatus}[] = [];

	loading: boolean = false;

	mounted() {
	  this.onExternalValueChanged();
	}

	getStatuses = () => {
	  const options : {key:string, value:DailyLoadProcessStatus}[] = [];
	  const statusKeys : string[] = Object.keys(DailyLoadProcessStatus);
	  for (let i = 0; i < statusKeys.length; i++) {
	    const statusString = statusKeys[i];
	    const statusEnum : DailyLoadProcessStatus = DailyLoadProcessStatus[
					statusString as keyof typeof DailyLoadProcessStatus
	    ];
	    const displayName: string = DailyLoadProcessStatuses.get(statusEnum)!;
	    options.push({ key: displayName, value: statusEnum });
	  }
	  return options;
	}

	@Watch('value')
	onExternalValueChanged() {
	  this.selectedValues = DailyLoadProcessStatusPicker.toSelectionPairs(this.value);
	}

	updateSelection(selected: {key:string, value:DailyLoadProcessStatus}[]) {
	  const values = [] as DailyLoadProcessStatus[];
	  if (selected) {
	    for (let i = 0; i < selected.length; i++) {
	      values.push(selected[i].value);
	    }
	  }
	  this.$emit('input', values);
	}

	static toSelectionPairs(values:DailyLoadProcessStatus[]) {
	  const pairs = [] as {key:string, value:DailyLoadProcessStatus}[];
	  if (!values) {
	    return pairs;
	  }
	  for (let i = 0; i < values.length; i++) {
	    pairs.push({ key: DailyLoadProcessStatuses.get(values[i])!, value: values[i] });
	  }
	  return pairs;
	}
}
